/**
 * Runtime environment detection for the SPA.
 *
 * Staging and production serve the SAME built bundle, so a build-time flag can't
 * tell them apart — we decide from the hostname at runtime. Used to badge the
 * browser tab title so a staging tab is obvious at a glance (the emoji stays
 * visible even when the tab is too narrow to read the text).
 */
export type AppEnv = 'staging' | 'production' | 'local';

const STAGING_HOST = 'app.takeoffandestimating.com.au';
const PROD_HOST = 'app.costed.app';

export function detectEnv(): AppEnv {
  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  if (host === STAGING_HOST) return 'staging';
  if (host === 'localhost' || host === '127.0.0.1' || host.endsWith('.local')) return 'local';
  // PROD_HOST and any other (unknown prod alias) -> no scary badge.
  if (host === PROD_HOST) return 'production';
  return 'production';
}

/** Tab-title badge for non-prod environments ('' for production). Emoji first so
 *  it survives tab truncation. */
export function envBadge(env: AppEnv = detectEnv()): string {
  switch (env) {
    case 'staging':
      return '🟠 STAGING';
    case 'local':
      return '🟢 DEV';
    default:
      return '';
  }
}

const DEFAULT_APP_TITLE = 'Costed.app';

/**
 * Set the document title with the environment badge prefixed. Call at startup and
 * anywhere a view overrides the title, e.g. `setAppTitle('Timesheet')`.
 */
export function setAppTitle(base: string = DEFAULT_APP_TITLE): void {
  if (typeof document === 'undefined') return;
  const badge = envBadge();
  document.title = badge ? `${badge} · ${base}` : base;
}
